module.exports = __webpack_public_path__ + "img/91.7a780b35.jpg";